import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Onboarding } from '@bciti/types';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { State } from 'src/app/store';
import { environmentSelector } from 'src/app/store/global/global.selectors';
import { OnboardingService } from './onboarding.service';

@Injectable({ providedIn: 'root' })
export class OnboardingServiceImpl implements OnboardingService {
    constructor(private store: Store<State>, private http: HttpClient) {}

    createOnboarding(onboarding: Onboarding): Observable<Onboarding> {
        return this.store.select(environmentSelector).pipe(switchMap((env) => this.http.post(`${env.baseUrl}/cerberus/onboarding`, onboarding).pipe(map((res) => res as Onboarding))));
    }

    updateOnboarding(onboarding: Onboarding): Observable<Onboarding> {
        return this.store
            .select(environmentSelector)
            .pipe(switchMap((env) => this.http.patch(`${env.baseUrl}/cerberus/onboarding/${onboarding.organisation.tag}`, onboarding).pipe(map((res) => res as Onboarding))));
    }

    completeOnbarding(tag: string) {
        return this.store.select(environmentSelector).pipe(switchMap((env) => this.http.post(`${env.baseUrl}/cerberus/onboarding/${tag}`, null).pipe(map((res) => res as Onboarding))));
    }

    uploadLogo(file: File): Observable<string> {
        const formData = new FormData();
        formData.append('file', file);
        return this.store
            .select(environmentSelector)
            .pipe(switchMap((env) => this.http.post(`${env.baseUrl}/cerberus/onboarding/fileupload/temp`, formData, { responseType: 'text' }).pipe(map((url) => url as string))));
    }

    handleError(error) {
        console.log(error);
    }

    getOnboardings(): Observable<Onboarding[]> {
        return this.store.select(environmentSelector).pipe(switchMap((env) => this.http.get(`${env.baseUrl}/cerberus/onboarding`).pipe(map((onboardings) => onboardings as Onboarding[]))));
    }

    getOnboardingById(id: string): Observable<Onboarding> {
        return this.store.select(environmentSelector).pipe(switchMap((env) => this.http.get(`${env.baseUrl}/cerberus/onboarding/${id}`).pipe(map((onboarding) => onboarding as Onboarding))));
    }
}

export const ONBOARDING_SERVICE = {
    provide: OnboardingService,
    useClass: OnboardingServiceImpl,
};
